import { useState } from "react"

export const useGlobalStates = () => {
    
    //para el formulario
    const [showFormContract, setShowFormContract ] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')

    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [showTypeForm, setshowTypeForm] = useState('None')

    // para el steper
    const [stepApplilication, setStepApplilication] = useState(0)


    return Object.freeze({
        showFormContract, setShowFormContract,
        formOpeningMode, setFormOpeningMode,
        stepApplilication, setStepApplilication,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        showTypeForm, setshowTypeForm
    })
}